export default __webpack_public_path__ + "static/beardguard-53e845d5883e3e3424d809b3ad3c8f10.jpg";